import { useMutation, useQueryClient } from 'react-query';

import {
  savePlannedHours,
  SavePlannedHoursOptions
} from 'RestAPIs/capacity-plan/baseplan';

import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

export const queryKeys = {
  BASEPLAN: 'baseplan',
  BASEPLANS: 'baseplans',
  PLANNED_HOURS: 'plannedHours'
};

export const useSaveAndUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (options: SavePlannedHoursOptions) => savePlannedHours(options),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([queryKeys.BASEPLAN]);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};
